const iconPicker = {
  pickIcon: "Pick icon",
  emoji: "Emoji",
  icons: "Icons",
  image: "Image",
  search: "Search...",
  all: "All",
  remove: "Remove icon",
  uploadFile: "Upload image",
  uploading: "Uploading...",
  orPasteUrl: "Or paste image URL",
  apply: "Apply",
  noResults: "No results",
  phosphor: "Phosphor",
  weight: "Weight",
  weightThin: "Thin",
  weightLight: "Light",
  weightRegular: "Regular",
  weightBold: "Bold",
  weightFill: "Fill",
  size: "Size",
  sizeAuto: "Auto",
  weightDuotone: "Duotone",
} as const;
export default iconPicker;
